module.exports = __webpack_public_path__ + "static/media/barcelona-las-ramblas.d69a7db6.jpg";